import SearchOffRounded from '@mui/icons-material/SearchOffRounded';
import { Card } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { EmptyState } from '../../../components/states';
import { BackLink } from '../components/ReportFrame';
import { REPORT_SCREENS } from './reportScreens';

export function ReportPage() {
  const { slug = '' } = useParams();
  const navigate = useNavigate();
  const Screen = REPORT_SCREENS[slug];
  if (!Screen)
    return (
      <>
        <BackLink to="/reports" label="All reports" />
        <Card>
          <EmptyState
            icon={<SearchOffRounded />}
            title="Report not found"
            body="This report doesn’t exist. Pick one from the reports list."
            action={{ label: 'All reports', onClick: () => void navigate('/reports') }}
          />
        </Card>
      </>
    );
  // Keyed by slug so filters and state reset when switching reports.
  return <Screen key={slug} />;
}
